import { render, staticRenderFns } from "./TagCreate.vue?vue&type=template&id=2f1a665e&lang=pug&"
import script from "./TagCreate.vue?vue&type=script&lang=js&"
export * from "./TagCreate.vue?vue&type=script&lang=js&"
import style0 from "./TagCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TagCreate.vue"
export default component.exports